// extracted by mini-css-extract-plugin
export default {"container":"wUrfYEVZz3ImKub8t87l","icon":"npIiRHl8WqG4rCp6HD_m","text":"rkOsY4Ob5EDdm_GELgr3"};